export default "__VITE_ASSET__DpJ4oGD1__$_?nuxt_component=async&nuxt_component_name=SvgoHomeFlagEuropean&nuxt_component_export=default__"